import React from "react";
import { Breadcrumb, Button, Col, Row } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";

const PageHeader = ({ items }) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Row align="middle" style={{ marginBottom: 16 }}>
      <Col>
        <ArrowLeftOutlined
          style={{ fontSize: 20 }}
          onClick={() => navigate(-1)}
        />
      </Col>
    </Row>
  );
};

export default PageHeader;
